import { ALL_COUNTRIES } from '../country-dropdown/countries.model';

// Punto único de la política del autocompletado de dirección: qué países lo habilitan.
// El país resuelto viaja al backend (includedRegionCodes/regionCode).
// Para restringir países en el futuro, cambiar ADDRESS_AUTOCOMPLETE_ALLOWED.
// Códigos en mayúscula, sin XK (no soportado por el backend).
const EXCLUDED_COUNTRY_CODE = 'XK';

export const ADDRESS_AUTOCOMPLETE_ALLOWED: readonly string[] = ALL_COUNTRIES.map((country) =>
  country.code.trim().toUpperCase(),
).filter((code) => code !== EXCLUDED_COUNTRY_CODE);

/** País informado (normalizado) si está habilitado; null si vacío o no habilitado. */
export function resolveAddressAutocompleteCountry(
  country: string | null | undefined,
  allowed: readonly string[] = ADDRESS_AUTOCOMPLETE_ALLOWED,
): string | null {
  const code = country?.trim().toUpperCase();
  return code && allowed.includes(code) ? code : null;
}
